// Types only: the engine host is loaded on first use, so the first load of the app carries none of it.
import type { StatePorts } from '@vitesse/statechart-host';
import type { ModelView } from '../../../core/domain/model';
import { childPorts } from '../../ai-tools/port-types';
import { stripForEngine } from '../../../sandbox/statechart/typescript';

/*
 * The ports of each state of a group's root, for the ghost tree of the Statechart tile (Step 3 of
 * docs/state-subgraph-plan.md). The engine host is large, so the page loads it only when a person
 * turns the tree on, as the check of a document does (model-check.ts). A `typescript` document is
 * read as the engine reads it: its types are stripped first, at the author's positions.
 */

/**
 * `statePorts` of the root's text, with the children's ports and the root's own inputs and outputs
 * of the view. Null when the host or the strip could not run: the tree then has nothing to show.
 */
export async function loadStatePorts(
  scxml: string,
  m: Pick<ModelView, 'children' | 'inputs' | 'outputs'>,
): Promise<Map<string, StatePorts> | null> {
  try {
    const [{ statePorts }, strip] = await Promise.all([import('@vitesse/statechart-host'), stripForEngine(scxml)]);
    return statePorts(scxml, { strip, children: childPorts(m.children), inputs: m.inputs, outputs: m.outputs });
  } catch {
    return null;
  }
}
